import { Bandeira, BandeiraSearchBox, error99, RetAPI } from "../../Utils/Types"
import { Api } from '../../Utils/api'
import { v4 as uuid } from 'uuid'
import { encode as base64_encode } from 'base-64'

export const BandeiraService = {

    GetAttributes: async (id?: string): Promise<RetAPI> => {

        const resp = await Api('Bandeiras/Attributes', 'get', { id })
        const attributes: Bandeira = {
            id: 0,
            id_empresa: 0,
            id_user_insert: 0,
            id_user_last_update: 0,
            id_user_exclusao: 0,
            dt_cadastro: '',
            dt_last_update: '',
            dh_exclusao: '',
            motivo_exclusao: '',
            name_user_insert: '',
            name_user_last_update: '',
            name_user_delete: '',
            nome: '',
            nome_resumido: '',
            cnpj: '',
            taxa: 0,
            dias: '',
            description: '',
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.bandeiras) {

                    attributes.id = resp.data.bandeiras.id
                    attributes.id_empresa = resp.data.bandeiras.id_empresa
                    attributes.id_user_insert = resp.data.bandeiras.id_user_insert
                    attributes.id_user_last_update = resp.data.bandeiras.id_user_last_update
                    attributes.id_user_exclusao = resp.data.bandeiras.id_user_exclusao
                    attributes.dt_cadastro = resp.data.bandeiras.dt_cadastro
                    attributes.dt_last_update = resp.data.bandeiras.dt_last_update
                    attributes.dh_exclusao = resp.data.bandeiras.dh_exclusao
                    attributes.motivo_exclusao = resp.data.bandeiras.motivo_exclusao
                    attributes.name_user_insert = resp.data.bandeiras.name_user_insert
                    attributes.name_user_last_update = resp.data.bandeiras.name_user_last_update
                    attributes.name_user_delete = resp.data.bandeiras.name_user_delete
                    attributes.nome = resp.data.bandeiras.nome
                    attributes.nome_resumido = resp.data.bandeiras.nome_resumido
                    attributes.cnpj = resp.data.bandeiras.cnpj
                    attributes.taxa = resp.data.bandeiras.taxa
                    attributes.dias = resp.data.bandeiras.dias
                    attributes.description = resp.data.bandeiras.description

                }
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes
            }
        }

        return {
            error: false,
            data: attributes
        }

    },

    Save: async (bandeira: any): Promise<RetAPI> => {

        let id = ''

        if (bandeira.id) {
            id = bandeira.id.toString()
        }

        const resp = await Api('Bandeiras/Save', 'post', {

            nome: bandeira.nome,
            nome_resumido: bandeira.nome_resumido,
            taxa: bandeira.taxa,
            dias: bandeira.dias,
            id
        })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: 'Dados da bandeira gravados com sucesso',
                id: resp.data.bandeiras.id,
                data: resp.data,
                dt_cadastro: resp.data.bandeiras.dt_cadastro,
                dt_last_update: resp.data.bandeiras.dt_last_update,
                name_user_insert: resp.data.bandeiras.name_user_insert,
                name_user_last_update: resp.data.bandeiras.name_user_last_update
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    Delete: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`Bandeiras/Delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }


    },

    Filter: async (filterBandeira: any): Promise<RetAPI> => {

        const resp = await Api('Bandeiras/Filter', 'get', { 
            field: filterBandeira.field, 
            filter_type: filterBandeira.filter_type, 
            filter: filterBandeira.filter
        })
        const bandeira: Bandeira[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: bandeira
                }
            }

            if (resp.data.error && resp.data.error === '0') {
                resp.data.bandeiras.map((item: any) => {
                    return bandeira.push({
                        id: item.id,
                        id_empresa: item.id_empresa,
                        id_user_insert: item.id_user_insert,
                        id_user_last_update: item.id_user_last_update,
                        id_user_exclusao: item.id_user_exclusao,
                        dt_cadastro: item.dt_cadastro,
                        dt_last_update: item.dt_last_update,
                        dh_exclusao: item.dh_exclusao,
                        motivo_exclusao: item.motivo_exclusao,
                        name_user_insert: item.name_user_insert,
                        name_user_last_update: item.name_user_last_update,
                        name_user_delete: item.name_user_delete,
                        nome: item.nome,
                        nome_resumido: item.nome_resumido,
                        cnpj: item.cnpj,
                        taxa: item.taxa,
                        dias: item.dias,
                        description: item.nome,

                    })
                })
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: bandeira
            }
        }

        return {
            error: false,
            data: bandeira
        }

    },

    FilterExcluidas: async (filterBandeira: any): Promise<RetAPI> => {

        const resp = await Api('Bandeiras/Filter/Excluidas', 'get', {
            datai: filterBandeira.datai,
            dataf: filterBandeira.dataf,
            nome_bandeira: filterBandeira.nome_bandeira,
        })
        const bandeira: Bandeira[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: bandeira
                }
            }

            if (resp.data.error && resp.data.error === '0') {
                resp.data.bandeiras.map((item: any) => {
                    return bandeira.push({
                        id: item.id,
                        id_empresa: item.id_empresa,
                        id_user_insert: item.id_user_insert,
                        id_user_last_update: item.id_user_last_update,
                        id_user_exclusao: item.id_user_exclusao,
                        dt_cadastro: item.dt_cadastro,
                        dt_last_update: item.dt_last_update,
                        dh_exclusao: item.dh_exclusao,
                        motivo_exclusao: item.motivo_exclusao,
                        name_user_insert: item.name_user_insert,
                        name_user_last_update: item.name_user_last_update,
                        name_user_delete: item.name_user_delete,
                        nome: item.nome,
                        nome_resumido: item.nome_resumido,
                        cnpj: item.cnpj,
                        taxa: item.taxa,
                        dias: item.dias,
                        description: item.nome,

                    })
                })
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: bandeira
            }
        }

        return {
            error: false,
            data: bandeira
        }

    },

    GetListBandeira: async (): Promise<RetAPI> => {

        const resp = await Api('Bandeiras/List', 'get')
        const bandeira: BandeiraSearchBox[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: bandeira
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.bandeiras.map((item: any) => {
                    return bandeira.push({

                        id: item.id,
                        description: item.nome,

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: bandeira
            }
        }

        return {
            error: false,
            data: bandeira
        }
    },
}